import { render, staticRenderFns } from "./loanList.vue?vue&type=template&id=bba59d2e&scoped=true&"
import script from "./loanList.vue?vue&type=script&lang=js&"
export * from "./loanList.vue?vue&type=script&lang=js&"
import style0 from "./loanList.vue?vue&type=style&index=0&id=bba59d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba59d2e",
  null
  
)

export default component.exports